import React, { useState, useEffect } from "react"
import { usePageContext } from "vike-react/usePageContext"
import Value from "aldoo-ra/Value"
import { navigate } from "aldoo-ra/Navigate"
import { PermissionAPI } from "aldoo-ra/Permissions"

const RBAC = ({ permission, grantAt: GrantAt }) => {
  return (Component) => {
    return function RBACWrapper(props) {
      const pageContext = usePageContext()
      const [auth] = Value("user-credentials")
      const urlPathname = pageContext.urlPathname
      
      const [isClient, setIsClient] = useState(false)
      const [granted, setGranted] = useState(false)
      const [loading, setLoading] = useState(true)

      useEffect(() => {
        setIsClient(true)
      }, [])

      useEffect(() => {
        const checkPermission = async () => {
          if (!isClient || auth === undefined) return
          
          if (!auth) {
            setGranted(false)
            setLoading(false)
            return
          }

          if (!permission) {
            // No permission required, just check if authenticated
            setGranted(true)
            setLoading(false)
            return
          }

          if (!auth._id) {
            // User doesn't have ID, deny access
            setGranted(false)
            setLoading(false)
            return
          }

          try {
            const hasPermission = await PermissionAPI.hasPermission(auth._id, permission)
            setGranted(hasPermission)
          } catch (error) {
            console.error("RBAC: Permission check failed:", error)
            setGranted(false)
          } finally {
            setLoading(false)
          }
        }

        checkPermission()
      }, [isClient, auth, permission])

      useEffect(() => {
        if (!loading && !granted && typeof GrantAt === "string") {
          navigate(GrantAt)
        }
      }, [loading, granted, GrantAt])

      if (!granted && typeof GrantAt === "string") return null

      return (
        <div suppressHydrationWarning>
          {isClient ? (
            loading ? (
              <div>Loading...</div>
            ) : granted ? (
              <Component {...props} />
            ) : (
              <GrantAt {...props} redirect={urlPathname} />
            )
          ) : (
            <div style={{ visibility: "hidden" }}>
              {/* Server-side placeholder */}
            </div>
          )}
        </div>
      )
    }
  }
}

export default RBAC